var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.dynamicComponent,{key:_vm.dynamicComponent,tag:"component",attrs:{"module":_vm.module},on:{"submit":_vm.onConfirmSubmit}})
}
var staticRenderFns = []

export { render, staticRenderFns }